import { KoDate, KoForm, KoFormBuilder, KoSelect, KoRichTextEditor } from 'packages';
import { useEffect } from 'react';
import styles from './curd.module.scss';
import { TIMESPEND } from 'shared/commonConstants';
import { useSelector } from 'react-redux';


const WorkLogCrud = ({ form, handleFinish, initialValues}) => {
  const holidays = useSelector(state => state?.holidays);

  useEffect(() => {
    if (!initialValues || Object.keys(initialValues).length === 0) {
      form?.resetFields();
    } else {
      form?.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);


  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        holidays={holidays['data']}
        onChange={(v) => onChange(v)}/>
    );
  };

  const Billable = ({ value, onChange }) => {
    console.log('value', value);
    return (
      <KoSelect
        value={value}
        placeholder="Select Billing Type"
        showSearch
        onChange={(v) => onChange(v)}
        options={[{ value: true, label: 'Billable', key: true},
          { value: false, label: 'Non - Billable', key: false}]} />
    );
  };

  const enabledButtons = {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    numberedList: true,
    unorderedList: true,
    codeBlock: true,
    link: true,
    insertTable: true,
    uploadImageButton: true,
    uploadVideoButton: true
  };
  
  const Description = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons}
      value={value}
      initialValues={value}
      form={form} name='description'
      onSetEditorValues={v => onChange(v)}
    />;

  
  const TimeSpentSelect = ({ value, onChange }) => {
    return (
      <KoSelect
        value={value || undefined}
        placeholder="Ex: 1w 3d 6h 20m"
        showSearch
        onChange={(v) => onChange(v)}
        options={TIMESPEND}     />
    );
  };

  const Meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'date', label: 'Date', colSpan: 2,
        widget: Date, rules: [
          {
            required: true,
            message: `Please select date.`
          }
        ]
      },
      {
        key: 'isBillable', label: 'Billable / Non-Billable', colSpan: 2,widget: Billable
      },
      {
        key: 'timeSpent', label: 'Time spent', colSpan: 2, placeholder: 'Ex: 1w 3d 6h 20m',  widget: TimeSpentSelect,
        rules: [
          {
            required: true,
            message: `Please enter time spent.`
          }
        ]
      },
      {
        key: 'timeRemaining', label: 'Time remaining', colSpan: 2, placeholder: 'Ex: 1w 3d 6h 20m',  widget: TimeSpentSelect
      },
      {
        key: 'description', widget: Description, label: 'Description', colSpan: 4, placeholder: 'Enter description'
      }
      
    ]
  };

  return (<div className={`${styles.subTaskWrapper} ${styles.formLayout}`}>
    <KoForm form={form} layout="vertical" onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={Meta} />
    </KoForm>
  </div>);
};

export default WorkLogCrud;
